export default __webpack_public_path__ + "static/media/home-design-agency-img-01.d8e59bc5.jpg";